import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { Clapperboard } from "lucide-react";
import api from "@/lib/api";
import { KIND_LABEL } from "@/components/shownotes/meta";

const MONTHS = ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"];
const shortDate = (d) => { const [, m, day] = (d || "").split("-"); return m ? `${MONTHS[+m - 1]} ${+day}` : ""; };

// Member dashboard header pill: newest Rehearsal/Show Notes published to my productions in the last 24 hours.
export default function ShowNotesBadge() {
  const [data, setData] = useState(null);
  useEffect(() => { api.get("/show-notes/recent").then(({ data }) => setData(data)).catch(() => {}); }, []);
  const n = data?.latest;
  if (!n) return null;
  return (
    <Link to="/member/show-notes?tab=archive" data-testid="member-show-notes-badge" title={`${KIND_LABEL[n.kind]} for ${n.production_name}`}
      className="inline-flex items-center gap-2 rounded-full border border-rose-200 bg-rose-50 py-1 pl-1 pr-3.5 text-sm font-semibold text-rose-700 shadow-sm transition-colors hover:bg-rose-100 animate-fade-in-up">
      <span className="flex h-7 w-7 items-center justify-center rounded-full bg-rose-100"><Clapperboard className="h-4 w-4" /></span>
      <span data-testid="member-show-notes-badge-label">{KIND_LABEL[n.kind]} · {shortDate(n.date)}</span>
      {data.more > 0 && <span className="text-xs font-bold text-rose-500" data-testid="member-show-notes-badge-more">+{data.more} more</span>}
    </Link>
  );
}
